import * as React from 'react';
import * as ReactDOM from 'react-dom';

import { Provider } from 'react-redux';

import App from './components/app.component';
import registerServiceWorker from './registerServiceWorker';
import configureStore from './store/configureStore';

import './index.scss';
import './analytics';

const store = configureStore();

const app = (
    <Provider store={store}>
      <App/>
    </Provider>
);

ReactDOM.render(
    app,
    document.getElementById('root') as HTMLElement
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx